import { render, staticRenderFns } from "./HearingAidShow.vue?vue&type=template&id=065a7fe8&"
import script from "./HearingAidShow.vue?vue&type=script&lang=js&"
export * from "./HearingAidShow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports